import { useEffect, useState } from 'react';
import React from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom'
import { factorIndex} from '../../features/dashboard/FactorSlice';
import Loading from '../../Loading';
import Header from './Header';
import Input from '../form/Input';
import Broadcast from './Broadcast';
import { Calendar } from "react-multi-date-picker";
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import SectionOneEditModel from './SectionOneEditModel'
import Button from '../../component/form/Button'
import Message from '../form/Message'
import DataTable, { ExpanderComponentProps } from 'react-data-table-component';
import axios from 'axios';
import { host } from '../../function/api'
import * as Icon from 'react-feather';
import $ from 'jquery'
import * as moment from 'jalali-moment';

function Customers() {

    const columns = [
        {
            name: '#',
            sortable: true,
            cell: (row, index) => <div className='rahpardaznet-border'>{index + 1} </div>,

        },

        {
            name: 'شماره بدنه',
            sortable: true,
            cell: row => <div className='rahpardaznet-border'>{row.bodyno}</div>
        },
        {

            name: 'کدملی',
            sortable: true,
            cell: row => <div className='rahpardaznet-border'>{row.nationalCode}</div>
        },
        {
            name: 'تاریخ ایجاد',
            sortable: true,
            cell: row => <div className="rahpardaznet-border">{moment(row.created_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}</div>
        },
        {
            name: 'تاریخ بروزرسانی',
            sortable: true,
            cell: row => <div className="rahpardaznet-border">{moment(row.updated_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}</div>
        },


    ];
    // $data = SectionOne::orderByRaw('RAND()')->get();
    // $data = SectionOne::inRandomOrder()->get();
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const token = localStorage.getItem('token')
    const date = new DateObject({ calendar: persian, locale: persian_fa })
    const [usersList, setUsers] = useState({});
    const [page, setPage] = useState(1);
    const countPerPage = 10;


    let {
        sections,
        loading,
        success,
        customers,
        customerDocumentList,
        message,
        error,
        errorType,
        errorNumber
    } = useSelector(state => state.customer)
    const [edit, setEdit] = useState()
    const [title, setTitle] = useState()
    const [name, setName] = useState()
    const [flag, setFlag] = useState()
    const [type, setType] = useState('')
    const [number, setNumber] = useState('')
    let [modalShow, setModalShow] = useState(false)
    const editHandler = (id, name, plag) => {
        setEdit(id)
        setName(name)
        setFlag(plag)
        setModalShow(true)
        message = ''

    }

    const closeButtonHandler = () => {
        message = ''
        setModalShow(false)
    }

    const searchCustomerHandler = () => {
        const data = {
            'type': type,
            'number': number
        }
        dispatch(searchCustomer(data))
    }

    const customerDocumentsHandler = (customer_id) => {
        const data = {
            'customer_id': customer_id
        }
        dispatch(documentList(data))
    }


    const getUserList = async (search = pinCode, pageNumber = page) => {
        $('.dlUCce').addClass('loading');

        try {
            const response = await axios({
                method: 'GET',
                url: `${host}factors?page=${pageNumber}&per_page=${countPerPage}&search=${search}&delay=1`,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            // var usersList = JSON.stringify(response.data);
            setUsers(response.data.data);
            console.log(usersList);

            console.log(usersList);
            $('.dlUCce').removeClass('loading');

        } catch (error) {
            setUsers({});
            $('.dlUCce').removeClass('loading');
        }
    };
    function searchByDataTable(event) {
        let delayTimeOutFunction;
        delayTimeOutFunction = setTimeout(() => {
            getUserList(event.target.value);


        }, 3000); // denounce delay

        return () => clearTimeout(delayTimeOutFunction);

    };
    const [pinCode, setPinCode] = useState("");
    useEffect(() => {
        getUserList()
    }, []);

    const rahkarpardaznet_search_datatable = (e) => {
        e.preventDefault();
        setPage(1);

        $('#pagination-first-page').trigger('click');
        getUserList(pinCode, 1);
    }

    const handlePageChange = (page) => {
        setPage(page);
        getUserList('', page);
    };

    useEffect(() => {
        dispatch(factorIndex(token))
        if (modalShow === false) {
            message = ''
        }
    }, [modalShow])

    return (
        <>
            {loading === true ? (<Loading />) : null}
            <Broadcast title={'لیست فاکتورها'} />
                <div className='row g-2 pr-3 pl-3 pb-4'>

                    <div className="App">
                        <form onSubmit={rahkarpardaznet_search_datatable} className="rk-search-bar">
                            <input type="text" id="" placeholder='جستجو کنید' onChange={(event) => setPinCode(event.target.value)} />
                            <button type="submit"><Icon.Search /></button>

                        </form>
                        <DataTable
                            title=""
                            columns={columns}
                            data={usersList.data}
                            className='rahpardaznet-table-user'
                            highlightOnHover
                            pagination
                            paginationServer
                            paginationTotalRows={usersList.total}
                            paginationPerPage={countPerPage}
                            paginationComponentOptions={{
                                noRowsPerPage: true
                            }}
                            onChangePage={handlePageChange}
                        />
                    </div>


                </div>

        </>
    )
}

export default Customers;